import React, { useState, useEffect } from "react";
import API from "../../utils/api";
import ConfirmActionModal from "./ConfirmActionModal";
const ReviewsModal = ({ isOpen, onClose, reviews, companyId, directoryId, overallRating,
    totalRatings,
    companyName, }) => {
    const [flaggedReviews, setFlaggedReviews] = useState([]);
    const [showConfirmation, setShowConfirmation] = useState(false);
    const [confirmationMessage, setConfirmationMessage] = useState("");



    useEffect(() => {
        if (isOpen && companyId) {
            const fetchFlaggedReviews = async () => {
                try {
                    const res = await API.get("/reviews/flagged", {
                        params: { companyId, directoryId },
                    });
                    const list = Array.isArray(res.data.flaggedReviews) ? res.data.flaggedReviews : [];
                    setFlaggedReviews(list);

                } catch (err) {
                    console.error("Failed to fetch flagged reviews", err);
                    setFlaggedReviews([]); // fallback to empty array on error
                }
            };

            fetchFlaggedReviews();
        }
    }, [isOpen, companyId, directoryId]);



    console.log("companyId", companyId);
    if (!isOpen) return null;
    const handleFlagReview = async (review) => {
        try {
            await API.post("/reviews/flag", {
                reviewId: review.reviewId,
                comment: review.comment,
                starRating: {
                    ONE: 1,
                    TWO: 2,
                    THREE: 3,
                    FOUR: 4,
                    FIVE: 5,
                }[review.starRating] || 0,
                createTime: review.createTime,
                reviewer: review.reviewer,
                companyId,
                directoryId,
                directoryName: review.directoryName || "Google",
            });

            setConfirmationMessage("Review flagged successfully!");
            setShowConfirmation(true);

            setFlaggedReviews((prev) => [...prev, { reviewId: review.reviewId, status: "pending" }]); // ✅ full object with status

        } catch (error) {
            console.error("Error flagging review:", error?.response?.data || error);
            alert("Something went wrong.");
        }
    };


    return (
        <div className="fixed inset-0 z-50 bg-black/50 flex items-center justify-center">
            <div className="bg-white rounded-xl shadow-lg w-full max-w-6xl p-6 relative">
                <div className="flex items-center justify-between mb-8"><h2 className="text-xl font-semibold ">

                    {companyName} — {overallRating} ★ ({totalRatings} reviews)


                    {/* <span className="text-purple-600">{company.name}</span> */}
                </h2>
                    <div className="text-right  ">
                        <button
                            onClick={onClose}
                            className="text-gray-600 bg-gray-900 rounded-md text-white  px-4 py-2"
                        >
                            Close
                        </button>
                    </div></div>

                <div className="overflow-x-auto max-h-[400px]">
                    <table className="min-w-full border rounded-md text-sm">
                        <thead className="bg-gray-100 text-gray-700">
                            <tr>
                                <th className="py-2 px-4 text-left w-1/5">Reviewer</th>   {/* 25% width */}
                                <th className="py-2 px-4 text-left w-1/8">Rating</th>     {/* ~16% */}
                                <th className="py-2 px-4 text-left w-1/2">Comment</th>    {/* ~33% */}
                                <th className="py-2 px-4 text-left w-1/6">Date</th>       {/* ~16% */}
                                <th className="py-2 px-4 text-left w-1/5">Action</th>     {/* 25% width */}

                            </tr>
                        </thead>
                        <tbody>
                            {reviews?.length > 0 ? (
                                reviews.map((review) => {
                                    // ✅ Convert rating string (e.g., "FIVE") into a number
                                    const ratingMap = {
                                        ONE: 1,
                                        TWO: 2,
                                        THREE: 3,
                                        FOUR: 4,
                                        FIVE: 5,
                                    };
                                    const rating = ratingMap[review?.starRating?.toUpperCase()] || 0;

                                    // ✅ Format date into something readable
                                    const formattedDate = review?.updateTime
                                        ? new Date(review.updateTime).toLocaleDateString("en-US", {
                                            year: "numeric",
                                            month: "short",
                                            day: "numeric",
                                        })
                                        : "";

                                    return (
                                        <tr key={review.reviewId} className="border-t">
                                            <td className="py-2 px-4 flex items-center gap-2">
                                                {review.reviewer?.profilePhotoUrl && (
                                                    <img
                                                        src={review?.reviewer?.profilePhotoUrl}
                                                        alt="profile"
                                                        className="w-6 h-6 rounded-full"
                                                    />
                                                )}
                                                {review?.reviewer?.displayName || "Anonymous"}
                                            </td>

                                            {/* ⭐ Rating Stars */}
                                            <td className="py-2 px-4 text-yellow-500">
                                                {"★".repeat(rating) + "☆".repeat(5 - rating)}
                                            </td>

                                            <td className="py-2 px-4">{review?.comment}</td>

                                            {/* 📅 Formatted Date */}
                                            <td className="py-2 px-4">{formattedDate}</td>

                                            <td>
                                                {(() => {
                                                    const flagged = flaggedReviews.find(
                                                        (f) => f.reviewId === review.reviewId
                                                    );
                                                    if (flagged) {
                                                        const color =
                                                            flagged.status === "approved"
                                                                ? "text-green-600"
                                                                : flagged.status === "disapproved"
                                                                    ? "text-red-600"
                                                                    : "text-gray-600";

                                                        return (
                                                            <span className={`font-semibold ${color}`}>
                                                                {flagged.status.charAt(0).toUpperCase() +
                                                                    flagged.status.slice(1)}
                                                            </span>
                                                        );
                                                    }

                                                    return (
                                                        <button
                                                            className="text-red-600 hover:underline"
                                                            onClick={() => handleFlagReview(review)}
                                                        >
                                                            Flag the review
                                                        </button>
                                                    );
                                                })()}
                                            </td>
                                        </tr>
                                    );
                                })
                            ) : (
                                <tr>
                                    <td colSpan={5} className="text-center py-4 text-gray-500">
                                        No reviews available.
                                    </td>
                                </tr>
                            )}

                        </tbody>
                    </table>
                </div>
            </div>
            <ConfirmActionModal
                isOpen={showConfirmation}
                title="Success"
                message={confirmationMessage}
                onConfirm={() => setShowConfirmation(false)}
                confirmText="OK"
                confirmColor="blue"
                showCancelButton={false}
            />

        </div>

    );
};

export default ReviewsModal;
